/**
 * @generated SignedSource<<3450cb92a413bedee309c83871168423>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PlansList_navigationCustomisation$data = {
  readonly sidebar: {
    readonly nodes: ReadonlyArray<{
      readonly menuId: string | null;
      readonly visible: boolean | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "PlansList_navigationCustomisation";
};
export type PlansList_navigationCustomisation$key = {
  readonly " $data"?: PlansList_navigationCustomisation$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlansList_navigationCustomisation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "PlansList_navigationCustomisation",
  "selections": [
    {
      "concreteType": "SettingsMenuItemConnection",
      "kind": "LinkedField",
      "name": "sidebar",
      "plural": false,
      "selections": [
        {
          "concreteType": "SettingsMenuItem",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "menuId"
            },
            {
              "kind": "ScalarField",
              "name": "visible"
            }
          ]
        }
      ]
    }
  ],
  "type": "SettingsNavigationCustomisation"
};

(node as any).hash = "4a2365d41e4dcdcefc0564da02f00873";

export default node;
